import { ICategoryResponse, IService, IServiceAdminListResponse, IServiceResponse } from '@bciti/types';
import { Observable } from 'rxjs';
import {
    CreateServiceCategoryPayload,
    CreateServiceStatusPayload,
    Service,
    ServiceCategoryAdminResponse,
    ServiceStatus,
    ServiceStatusAdminResponse,
    CreateUpdateServicePayload,
    UpdateServiceCategoryPayload,
    UpdateServiceStatusPayload,
    UpdateServicePayload,
} from './service-state.model';

export abstract class ServiceStateService {
    abstract getServices(): Observable<Service[]>;
    abstract createService(service: Service): Observable<Service>;
    abstract updateService(service: UpdateServicePayload): Observable<CreateUpdateServicePayload>;
    abstract updateServiceOrder(service: Service): Observable<Service[]>;
    abstract deleteService(id: string): Observable<any>;
    abstract duplicateService(id: string): Observable<Service>;

    abstract getServiceCategories(): Observable<ServiceCategoryAdminResponse[]>;
    abstract createServiceCategory(category: CreateServiceCategoryPayload): Observable<ServiceCategoryAdminResponse>;
    abstract updateServiceCategory(category: UpdateServiceCategoryPayload): Observable<ServiceCategoryAdminResponse>;
    abstract deleteServiceCategory(id: string): Observable<any>;

    abstract getServiceStatuses(): Observable<ServiceStatus[]>;
    abstract createServiceStatus(status: CreateServiceStatusPayload): Observable<ServiceStatusAdminResponse>;
    abstract updateServiceStatus(status: UpdateServiceStatusPayload): Observable<ServiceStatusAdminResponse>;
    abstract deleteServiceStatus(id: string): Observable<any>;

    abstract postDocuments(document: any): Observable<string[]>;
    abstract getService(id: string): Observable<IService>;
    abstract editService(id: string, payload: IService): Observable<IServiceResponse>;
}
